module.exports = __webpack_public_path__ + "static/img/illustratepic_02.1d0bf32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-TW/illustratepic_02.png
// module id = D5Au
// module chunks = 1